module.exports = __webpack_public_path__ + "img/3_140.495d87d4.png";